const LABELS: Record<string, { label: string; tone: 'success' | 'pending' | 'rejected' | 'neutral' }> = {
  NOT_REQUESTED: { label: 'Not Requested', tone: 'neutral' },
  NOT_SUBMITTED: { label: 'Not Submitted', tone: 'neutral' },
  DRAFT: { label: 'Draft', tone: 'neutral' },
  CHANGES_REQUESTED: { label: 'Changes Requested', tone: 'rejected' },
  PENDING: { label: 'Pending', tone: 'pending' },
  AVAILABLE: { label: 'Available', tone: 'success' },
  APPROVED: { label: 'Approved', tone: 'success' },
  DENIED: { label: 'Denied', tone: 'rejected' },
  REJECTED: { label: 'Rejected', tone: 'rejected' },
  RETRACTED: { label: 'Retracted', tone: 'rejected' },
  FAILED: { label: 'Failed', tone: 'rejected' },
  SUBMITTED: { label: 'Pending', tone: 'pending' },
  REMOTE_SALES: { label: 'Remote Sales', tone: 'success' },
  FIELD_SALES: { label: 'Field Sales', tone: 'success' },
};

export function StatusBadge({ status }: { status: string }) {
  const validationStyle = status in validationStatusStyles ? validationStatusStyles[status as ValidationStatus] : null;
  const meta = validationStyle ? { label: validationStyle.label === 'Reviewing your documents...' ? 'Pending' : validationStyle.label, tone: validationStyle.badgeTone } : LABELS[status] ?? { label: status, tone: 'neutral' as const };
  return <span className={`status-badge ${meta.tone}`}>{meta.label}</span>;
}
import { validationStatusStyles, type ValidationStatus } from './DocumentValidationPanel';
